export default "/images/5a3c21910cd062d2f0d60a107a77dff0.avif";